import { isMobile, isTV } from 'app/device';

export const maxCols = isTV ? 6 : isMobile ? 4 : 5;
